import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { defineMessages, injectIntl } from "react-intl";
import useI18n from "../hooks/useI18n";

const countryMessages = defineMessages({
    fi: { id: "Suomi", defaultMessage: "Finland" },
    se: { id: "Ruotsi", defaultMessage: "Sweden" },
    no: { id: "Norja", defaultMessage: "Norway" }
});

const LandingCard = ({ icon, title, content, country, intl }) => {
    const { getCountryFlag } = useI18n();
    return (
        <div className='col-lg col-md-4'>
            <div className="card landing">
                {icon && <FontAwesomeIcon icon={icon} className="icon" />}
                {country && getCountryFlag(country) && (
                    <div className="d-flex align-items-center gap-2 mb-3">
                        <img src={getCountryFlag(country)} alt="" aria-hidden="true" width={16} height={16} />
                        <span className="text-muted small">{intl.formatMessage(countryMessages[country])}</span>
                    </div>
                )}
                <h2 className="fw-bold mb-1">{title}</h2>
                <p className="mb-0 text-break">{content}</p>
            </div>
        </div>
    );
}

LandingCard.propTypes = {
    icon: PropTypes.object,
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    country: PropTypes.string,
    intl: PropTypes.object.isRequired
};

export default injectIntl(LandingCard);